import { useQuery, QueryHookOptions } from '@apollo/client';
import { GET_BOOSTS_PERFORMANCE_STATS_FOR_OFFER } from '../queries/getPerformanceQuery';
import { GetBoostsPerformanceStatsForOffer, GetBoostsPerformanceStatsForOfferVariables } from '../queries/types/GetBoostsPerformanceStatsForOffer';

type TOptions = QueryHookOptions<GetBoostsPerformanceStatsForOffer, GetBoostsPerformanceStatsForOfferVariables>;

export const useGetBoostPerformanceData = (options: TOptions = {}) =>
  useQuery<GetBoostsPerformanceStatsForOffer, GetBoostsPerformanceStatsForOfferVariables>(
    GET_BOOSTS_PERFORMANCE_STATS_FOR_OFFER,
    options,
  );
